import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-ice px-5 py-20 sm:py-28" data-id="element-67" data-mp="e3dh7r4o3cpi">
      <div className="mx-auto max-w-6xl" data-id="element-68" data-mp="9copf4b6lxl">
        <div className="mx-auto max-w-3xl text-center" data-id="element-69" data-mp="598xdrnyb1jh">
          <p className="font-display text-sm font-bold text-brand" data-id="element-70" data-mp="57o1nypwhck1">
            <span aria-hidden="true" data-id="element-71" data-mp="3mh2xby0b67b1">🧠 </span>Der Unterschied von MATHE BEREIT™
          </p>
          <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-navy sm:text-5xl" data-id="element-72" data-mp="3rgyr74fakicv">
            Vom erschöpften Lehrer zur{' '}
            <span className="text-brand" data-id="element-73" data-mp="3dj0o4v6f88co">souveränen Lehrkraft.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-navy/70" data-id="element-74" data-mp="3ig0vd9f0bh5d">
            Gib deinem Mathematikunterricht mehr visuelle Wirkung, deinen Schülern mehr Klarheit und
            dir selbst endlich wieder die Zeit, das Unterrichten zu genießen.
          </p>
        </div>

        <dl className="mx-auto mt-12 grid max-w-4xl grid-cols-1 overflow-hidden rounded-2xl bg-white shadow-lift sm:grid-cols-3" data-id="element-75" data-mp="1j9cfosul4n4h">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ice-strong sm:border-l sm:border-t-0' : ''}`} data-id="element-76" data-mp="1sznl6jtx34dh" data-mpi={index}>
              <dt className="sr-only" data-id="element-77" data-mp="10ckw0ib4s5zw">{stat.label}</dt>
              <dd data-id="element-78" data-mp="wbhl8a7xx05j">
                <span className="block font-display text-3xl font-extrabold tracking-tight text-navy" data-id="element-79" data-mp="wc10tka4bcge">
                  {stat.value}
                </span>
                <span className="mt-1 block text-sm font-semibold text-brand" data-id="element-80" data-mp="15bntnhos79xu">{stat.label}</span>
                <span className="mt-0.5 block text-xs text-navy/55" data-id="element-81" data-mp="2lpdzasvju69l">{stat.sub}</span>
              </dd>
            </div>)}
        </dl>

        <div className="relative mt-14 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-82" data-mp="2gprm2jfq0q0s">
          <div className="rounded-3xl bg-white p-7 ring-1 ring-ice-strong sm:p-10" data-id="element-83" data-mp="2os0jeaqefcu8">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-cherry" data-id="element-84" data-mp="2ssb28nzahxqi">
              Vor MATHE BEREIT™
            </p>
            <h3 className="mt-2 font-display text-2xl font-extrabold tracking-tight text-navy sm:text-3xl" data-id="element-85" data-mp="2xt8igv0qohpd">
              Der Preis der Improvisation
            </h3>
            <ul className="mt-7 space-y-4" data-id="element-86" data-mp="253rss54i7ewu">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-navy/70" data-id="element-87" data-mp="2a2330gypnrfl">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cherry/10 text-cherry" data-id="element-88" data-mp="2f1phsuu6tfqi">
                    <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-89" data-mp="2jt7g1b4tt27s" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <span aria-hidden="true" className="absolute left-1/2 top-1/2 z-10 hidden h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-sun font-display text-base font-extrabold text-navy shadow-soft ring-8 ring-ice lg:flex" data-id="element-90" data-mp="1rak1yfo8yng7">
            VS.
          </span>

          <div className="rounded-3xl bg-navy p-7 text-white shadow-soft sm:p-10" data-id="element-91" data-mp="19w91vm5themg">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-sun" data-id="element-92" data-mp="14uthzxfdle5n">
              Mit MATHE BEREIT™
            </p>
            <h3 className="mt-2 font-display text-2xl font-extrabold tracking-tight sm:text-3xl" data-id="element-93" data-mp="w2rji4ova7y0">
              Das komplette System
            </h3>
            <ul className="mt-7 space-y-4" data-id="element-94" data-mp="r4ga1v2hhzgb">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[15px] font-medium leading-relaxed text-white/90" data-id="element-95" data-mp="m5mwk2n768g5">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-leaf text-white" data-id="element-96" data-mp="h47b49h3xzx8">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-97" data-mp="d60446cg4cz8" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-center font-display text-lg font-bold text-navy" data-id="element-98" data-mp="t27u0s2twyur">
          Ein komplettes System, um weniger zu planen und mit mehr Sicherheit zu unterrichten.
        </p>
      </div>
    </section>;
}